//Node Modules
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useRecoilValue, useRecoilValueLoadable } from "recoil";
import { Duration } from "luxon";

//BinaryForge Components
import { Note } from "../helpers";

//3rd Party Components
import { ProgressSpinner } from "primereact/progressspinner";

//Atoms
import { deviceSensorAlarmListAtom } from "../../atoms/alarm";
import { recentActivitySelector } from "../../atoms/dashboard";

//Helpers
import { getUiDateTime } from "../../helpers/DateUtils";

//Other
import { nav } from "../../config/navigation";

const formatEventDuration = (event, t) => {
	if (event.isLive) return t("alarm.group.details.events.ongoing");
	const seconds = event.duration ? event.duration : 0;
	return Duration.fromObject({ seconds }).rescale().toHuman({ unitDisplay: "narrow", listStyle: "narrow" }) || "---";
};

//Active alarms pinned prominently on top, then the latest scheme events
const ActivityFeed = () => {
	const { t } = useTranslation();
	const activeAlarms = useRecoilValue(deviceSensorAlarmListAtom);
	const { state, contents: recentEvents } = useRecoilValueLoadable(recentActivitySelector);

	return (
		<div className="flexVert gapRow-small">
			{(activeAlarms ?? []).map((alarm) => (
				<div key={alarm.id} className="activityFeed-row activityFeed-alarm">
					<span className="activityFeed-time">{getUiDateTime(alarm.updatedAt)}</span>
					<Link
						to={`${nav.device.base}/${alarm.device?.id}`}
						className="activityFeed-device fontWeight-bold"
						title={alarm.device?.name}
					>
						{alarm.device?.name}
					</Link>
					<span
						className="activityFeed-type fontColour-error fontWeight-bold"
						title={t("alarm.group.details.state.alarm")}
					>
						<i className="pi pi-exclamation-triangle" /> {t("alarm.group.details.state.alarm")}
					</span>
					<span className="activityFeed-duration">{t("alarm.group.details.events.ongoing")}</span>
				</div>
			))}
			{(activeAlarms ?? []).length === 0 && (
				<div className="flex aItems-center gap-small">
					<i className="pi pi-check-circle fontColour-success" />
					<span>{t("alarms.none.message")}</span>
				</div>
			)}

			{state === "loading" && (
				<div className="flex jContent-center">
					<ProgressSpinner strokeWidth="4" style={{ width: "48px", height: "48px" }} />
				</div>
			)}
			{state === "hasError" && (
				<Note
					messageKey={`Error: ${recentEvents?.message ?? recentEvents}`}
					icon="pi-exclamation-circle fontColour-error"
				/>
			)}
			{state === "hasValue" &&
				recentEvents.map((event) => (
					<div key={`${event.isLive ? "live" : "archive"}-${event.id}`} className="activityFeed-row">
						<span className="activityFeed-time">{getUiDateTime(event.updatedAt)}</span>
						<Link
							to={`${nav.device.base}/${event.deviceId}`}
							className="activityFeed-device"
							title={event.device?.name ?? event.deviceId}
						>
							{event.device?.name ?? event.deviceId}
						</Link>
						<span
							className="activityFeed-type"
							title={t("events.eventType.eventType", { context: event.eventType })}
						>
							{t("events.eventType.eventType", { context: event.eventType })}
						</span>
						<span className="activityFeed-duration">{formatEventDuration(event, t)}</span>
					</div>
				))}
		</div>
	);
};

export default ActivityFeed;
